import { CompanyPaymentProvider, PaymentMethod, PaymentProviderId } from './paymentProvider.types';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { paymentProviderSelectors } from './paymentProvider.state';
import { useDebugValue } from 'react';

export type UsePaymentProviderById = (params: { providerId: PaymentProviderId }) => CompanyPaymentProvider | null;

export const usePaymentProviderById: UsePaymentProviderById = ({ providerId }) => {
  const providers = useSelector<RootState, RootState['paymentProviders']>(state => state.paymentProviders);

  const provider = paymentProviderSelectors.selectById(providers, providerId) || null;

  useDebugValue(provider);

  return provider;
};

export type UsePaymentProvidersByCompanyId = (params: { companyId: string }) => CompanyPaymentProvider | null;

export const usePaymentProvidersByCompanyId: UsePaymentProvidersByCompanyId = ({ companyId }) => {
  const providers = useSelector<RootState, RootState['paymentProviders']>(state => state.paymentProviders);

  const companyProvider = useSelector<RootState, string>(
    state => state.paymentProviders.companyProviders[companyId] || ''
  );

  const result = paymentProviderSelectors.selectById(providers, companyProvider) || null;

  useDebugValue(result);

  return result;
};

export type UsePaymentMethodsByCompanyId = (params: { companyId: string }) => PaymentMethod[];

export const usePaymentMethodsByCompanyId: UsePaymentMethodsByCompanyId = ({ companyId }) => {
  const result = useSelector<RootState, PaymentMethod[]>(
    state => state.paymentProviders.companyPaymentMethods[companyId] || []
  );

  useDebugValue(result);

  return result;
};

export type UsePaymentMethods = () => PaymentMethod[];

export const usePaymentMethods: UsePaymentMethods = () => {
  const result = useSelector<RootState, PaymentMethod[]>(state => state.paymentProviders.paymentMethods);

  useDebugValue(result);

  return result;
};
